import general from 'services/locales/en/general';
import { LinkInfo } from './types';

export const legal: Record<string, LinkInfo> = {
  terms: {
    url: '/terms',
    label: general.sideBar.links.terms,
  },
  license: {
    url: '/license-agreement',
    label: general.sideBar.links.license,
  },
  privacy: {
    url: 'https://www.iubenda.com/privacy-policy/94072064/full-legal',
    label: general.sideBar.links.privacy,
  },
  imprint: {
    url: '/imprint',
    label: general.sideBar.links.imprint,
  },
};
